export const ClockIcon = ({ className }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_2452_112464)">
        <path
          d="M21 12.7499C20.6184 17.3699 16.7184 20.9999 12 20.9999C9.61305 20.9999 7.32387 20.0517 5.63604 18.3639C3.94821 16.6761 3 14.3869 3 11.9999C3 7.2815 6.63 3.3815 11.25 2.99994"
          stroke="black"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12 6.74994V11.9999H17.25"
          stroke="black"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15 4.49994C15.6213 4.49994 16.125 3.99626 16.125 3.37494C16.125 2.75362 15.6213 2.24994 15 2.24994C14.3787 2.24994 13.875 2.75362 13.875 3.37494C13.875 3.99626 14.3787 4.49994 15 4.49994Z"
          fill="black"
        />
        <path
          d="M18.375 6.74994C18.9963 6.74994 19.5 6.24626 19.5 5.62494C19.5 5.00362 18.9963 4.49994 18.375 4.49994C17.7537 4.49994 17.25 5.00362 17.25 5.62494C17.25 6.24626 17.7537 6.74994 18.375 6.74994Z"
          fill="black"
        />
        <path
          d="M20.625 10.125C21.2463 10.125 21.75 9.62132 21.75 9C21.75 8.37868 21.2463 7.875 20.625 7.875C20.0037 7.875 19.5 8.37868 19.5 9C19.5 9.62132 20.0037 10.125 20.625 10.125Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_2452_112464">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
